import {
  componentNameConstants,
  dlEventConstants,
  headerConstants,
} from "@repo/analytics/data-layer.constants";
import { DataLayerProps } from "@repo/analytics/data-layer-utils";
import { trackAnalyticsEvent } from "../../utils/AnalyticsUtils";

/**
 * FooterAccordionFunction.ts
 * Analytics handler for Footer Accordion button clicks and link clicks
 */

// Analytics event handler for Footer Accordion click
export function handleFooterAccordionClickDL(cta_text: string, tab_position: number = 0) {
  // Create analytics data object

  const data: DataLayerProps = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    element: headerConstants.EVENT_NAMES.FOOTER_ICON_CLICK,
    cta_text: cta_text,
    section_title: "footer",
    sub_section: "open",
    tab_position: String(tab_position),
  };

  trackAnalyticsEvent(data, undefined, "FooterAccordionClick");
}

/**
 * Analytics handler for footer link clicks
 * Tracks clicks on links within the footer accordion sections
 */
export function handleFooterLinkClickDL(
  cta_text: string,
  sec_title: string,
  destination_url: string
) {
  // Create analytics data object

  const data: DataLayerProps = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: "link",
    event_type: dlEventConstants.CLICK,
    element: headerConstants.EVENT_NAMES.FOOTER_LINK_CLICK,
    cta_text: cta_text,
    section_title: sec_title || "footer",
    sub_section: sec_title || "NA",
    destination_url,
  };

  trackAnalyticsEvent(data, undefined, "FooterLinkClick");
}

/**
 * Analytics handler for social media icon clicks
 * Tracks clicks on social media icons (Facebook, LinkedIn, Twitter, YouTube)
 */
export function handleFooterSocialMediaClickDL(
  platform: string,
  destination_url: string,
  sec_title: string,
  tab_position: number = 0
) {
  // Create analytics data object

  const data: DataLayerProps = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    element: headerConstants.EVENT_NAMES.FOOTER_ICON_CLICK,
    cta_text: platform,
    section_title: sec_title,
    sub_section: "NA",
    destination_url,
    tab_position: String(tab_position),
  };

  trackAnalyticsEvent(data, undefined, "FooterSocialMediaClick");
}

/**
 * Analytics handler for OurCompanies link clicks
 * Tracks clicks on corporate/company links in the OurCompanies section
 */
export function handleOurCompaniesClickDL(
  cta_text: string,
  destination_url: string,
  sub_sec: string,
  tab_position: number = 0
) {
  // Create analytics data object

  const data: DataLayerProps = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: "link",
    event_type: dlEventConstants.CLICK,
    element: headerConstants.EVENT_NAMES.FOOTER_LINK_CLICK,
    cta_text: cta_text,
    section_title: "footer",
    sub_section: sub_sec,
    destination_url,
    tab_position: String(tab_position),
  };

  trackAnalyticsEvent(data, undefined, "OurCompaniesClick");
}
